//Install
import React, { Component } from "react";

//Element
class Corporation extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB rj401n" },
            //Element
            React.createElement("li", { className: "S6pt64 C96Q4r" },
                //Element
                React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/hakkimizda" },
                    //Element
                    "Hakkımızda"
                )
            ),
            //Element
            React.createElement("li", { className: "S6pt64 C96Q4r" },
                //Element
                React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/tarihce" },
                    //Element
                    "Tarihçe"
                )
            ),
            //Element
            React.createElement("li", { className: "S6pt64 C96Q4r" },
                //Element
                React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/subeler" },
                    //Element
                    "Şubeler"
                )
            ),
            //Element
            React.createElement("li", { className: "S6pt64 C96Q4r" },
                //Element
                React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/yetki-belgeleri" },
                    //Element
                    "Yetki Belgeleri"
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Corporation;